'use client'

import Script from 'next/script'
import { useEffect, useState } from 'react'

const ZENDESK_WIDGET_KEY = 'c4d73afb-c6e3-412b-8ce6-a67219989455'

export function ZendeskWidget() {
  const [isOpen, setIsOpen] = useState<boolean | null>(null)

  useEffect(() => {
    let active = true

    const checkBusinessHours = async () => {
      try {
        const response = await fetch('/api/zendesk/business-hours')

        if (!response.ok) {
          if (active) setIsOpen(true)
          return
        }

        const data = await response.json()
        if (active) setIsOpen(Boolean(data?.isOpen))
      } catch {
        // Fail-open: show the widget if we cannot determine business hours
        if (active) setIsOpen(true)
      }
    }

    checkBusinessHours()

    return () => {
      active = false
    }
  }, [])

  if (!isOpen) return null

  return (
    <Script
      id="ze-snippet"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_WIDGET_KEY}`}
      strategy="afterInteractive"
      onReady={() => {
        if (window.zE) {
          window.zE('messenger:set', 'locale', 'id')
        }
      }}
    />
  )
}
